import React from 'react';
import { MotifButton, MotifChip } from '@ey-xd/motif-react';

export const PURSUIT_LEADER_CONSTANTS = {
  numberFormat: 'Number Format',
  current: 'Current',
  future: 'Future',
  commit: 'Commit',
  noCommit: 'No Commit',
};

export const button = () => <MotifButton>Submit</MotifButton>;

export const CurrentPill = () => (
  <MotifChip style={{ backgroundColor: '#ffe600', color: '#000000', border: 'none' }}>
    {PURSUIT_LEADER_CONSTANTS.current}
  </MotifChip>
);

export const FuturePillDashboard = () => (
  <MotifChip style={{ backgroundColor: '#E1E1E6', color: '#000000', border: 'none' }}>
    Future
  </MotifChip>
);

// export const PL_EMAIL = 'tim.kozack@ey.com';
// export const FORECAST_ID = 'tim.kozack@ey.com';
export const PL_START_DATE = '2023-10-01';
export const PL_END_DATE = '2024-12-31';
